// One number for calls, texts and WhatsApp. Owner-confirmed (Nov 2026).
export const OWNER_FIRST_NAME = "Maria";
export const PHONE_E164 = "+16784317222";
export const PHONE_DISPLAY = "(678) 431-7222";
export const TEL_HREF = `tel:${PHONE_E164}`;
const WHATSAPP_DIGITS = PHONE_E164.replace(/\D/g, "");

/** wa.me click-to-chat link with a prefilled message (opens the app on phones, WhatsApp Web on computers). */
export function whatsappHref(message: string) {
  return `https://wa.me/${WHATSAPP_DIGITS}?text=${encodeURIComponent(message)}`;
}
